import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.flipped ? 'flip-container flipped' : 'flip-container'},[_c('div',{staticClass:"flipper"},[_c('div',{staticClass:"front",on:{"mouseover":function($event){return _vm.handleMouseOver()}}},[_c(VCard,{staticClass:"elevation-0"},[_vm._t("front")],2)],1),_c('div',{staticClass:"back",on:{"mouseout":function($event){return _vm.handleMouseLeave()}}},[_c(VCard,{staticClass:"elevation-0"},[_vm._t("back")],2)],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }